module.exports = __webpack_public_path__ + "a7f54bda3a.svg";